import RootLayout from "@/layouts/RootLayout";
import PagesBreadcrumbs from "@/components/PagesBreadcrumbs/PagesBreadcrumbs";
import PageHeading from "@/components/headings/PageHeading";
import "./MedipayDescriptionPage.scss";

const MedipayDescriptionPage = () => {
  return (
    <RootLayout>
      <main id="main">
        <PagesBreadcrumbs />
        <section className="terms">
          <div className="container">
            <div className="terms__wrapper">
              <header className="terms__header">
                <PageHeading variant="h2">MEDIPAY – PŁAĆ PÓŹNIEJ</PageHeading>
              </header>
              <div className="terms__content">
                <p>
                  <strong>
                    Chcesz nową sylwetkę? Załatwmy to teraz – nie za pół roku!
                  </strong>
                </p>
                <p>
                  Jeśli zatrzymała Cię cena pakietu (899 zł - 1 799 zł) –
                  spokojnie. Mamy na to sposób. Zamiast odkładać marzenia na
                  później, skorzystaj z MediPay i zacznij działać od razu!
                </p>

                <p>
                  <strong>Co daje Ci MediPay?</strong>
                </p>
                <ul>
                  <li>
                    ✅ Trenujesz już dziś – płacisz do 30 dni później lub w
                    ratach.
                  </li>
                  <li>
                    ✅ Szybki i prosty wniosek online – całość w kilka minut.
                  </li>
                  <li>
                    ✅ Brak stresu o budżet – inwestujesz w siebie, ale nie
                    rezygnujesz z innych planów.
                  </li>
                </ul>

                <p>
                  <strong>Jak to wygląda?</strong>
                </p>
                <ul>
                  <li>👉 Wybierasz pakiet.</li>
                  <li>👉 Składasz wniosek online.</li>
                  <li>👉 Działasz bez wymówek!</li>
                </ul>

                <p>
                  <strong>Nie odkładaj swojej przemiany.</strong>
                  <br />
                  Twoje lepsze samopoczucie i pewność siebie nie powinny czekać!
                </p>

                <p>
                  <a
                    href="https://www.mediraty.pl/jak-to-dziala/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Dowiedz się więcej o MediPay ➔
                  </a>
                </p>

                <PageHeading variant="h3">Korzyści dla Ciebie</PageHeading>

                <p>
                  Finansowanie MediPay <strong>BY MEDIRATY</strong> przy zakupie
                  pakietu treningowego ma sens w wielu sytuacjach. Oto
                  najważniejsze powody, dla których warto:
                </p>

                <ol>
                  <li>
                    <strong>Potrzeba zmiany</strong> – Czujesz, że to ten
                    moment, ale nie chcesz czekać na uzbieranie całej kwoty.
                    MediPay pozwala Ci ruszyć tu i teraz, a nie za kilka
                    miesięcy.
                  </li>
                  <li>
                    <strong>Płynność finansowa</strong> – Zamiast jednorazowo
                    wyciągać z konta całą sumę, płacisz wygodnie w ratach. Twoje
                    codzienne wydatki pozostają pod kontrolą.
                  </li>
                  <li>
                    <strong>Motywacja</strong> – Decyzja o rozpoczęciu
                    współpracy z Trenerem Michałem to inwestycja w siebie.
                    Łatwiejszy dostęp do pakietu = większa szansa, że nie
                    odłożysz swoich celów na „kiedyś”.
                  </li>
                  <li>
                    <strong>Brak stresu</strong> – Nie musisz się zastanawiać,
                    czy wystarczy na wszystko. MediPay daje Ci komfort działania
                    bez niepotrzebnych blokad w głowie.
                  </li>
                  <li>
                    <strong>Jasne zasady</strong> – Wiesz od początku, ile i
                    kiedy płacisz. Żadnych ukrytych kosztów, żadnego
                    kombinowania.
                  </li>
                  <li>
                    <strong>Informacja o RRSO:</strong>
                    <br />
                    Dla odroczenia płatności MediPay do 30 dni RRSO wynosi{" "}
                    <strong>0%</strong>.<br />W przypadku rozłożenia płatności
                    na raty – dla kwoty finansowania{" "}
                    <strong>1 799,00 zł</strong> ze spłatą w 8 równych ratach
                    miesięcznych po <strong>270,30 zł</strong>, oprocentowanie
                    stałe: 9,25%, całkowita kwota do spłaty wyniesie:{" "}
                    <strong>2 162,39 zł</strong>, w tym: opłata przygotowawcza:
                    299,75 zł, odsetki: 63,64 zł, całkowity koszt finansowania:
                    363,39 zł, Rzeczywista Roczna Stopa Oprocentowania (RRSO)
                    wyniesie: <strong>65,14%</strong>.
                    <br />
                    Wyliczenia zostały przygotowane na dzień 21.03.2025 r.
                    Instytucją finansującą jest <strong>LM PAY S.A.</strong> z
                    siedzibą w Warszawie przy ul. Lechickiej 23A.
                  </li>
                </ol>

                <PageHeading variant="h3">
                  Często zadawane pytania (FAQ)
                </PageHeading>

                <p>
                  <strong>Kto może skorzystać z MediPay?</strong>
                  <br />Z MediPay może skorzystać osoba z polskim obywatelstwem,
                  mająca ukończone 18 lat.
                </p>

                <p>
                  <strong>Jaką kwotę można sfinansować przez MediPay?</strong>
                  <br />
                  Dzięki MediPay płatność od 50 zł do 5 000 zł możesz odłożyć do
                  30 dni bez dodatkowych kosztów lub spłacić w 3, 4, 8 lub 12
                  równych miesięcznych częściach.
                </p>

                <p>
                  <strong>
                    Jak uzyskać informacje lub pomoc w sprawie finansowania?
                  </strong>
                  <br />
                  Telefoniczna obsługa Klienta:{" "}
                  <strong>pon-pt 8:00–20:00</strong>,{" "}
                  <strong>soboty 9:00–14:00</strong> pod numerem:{" "}
                  <strong>22 266 83 70</strong>.<br />
                  Rozmowę z Konsultantem można także zamówić przez formularz na
                  stronie:{" "}
                  <a
                    href="https://www.mediraty.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    mediraty.pl
                  </a>
                  <br />
                  Zapytania i sugestie można też przesyłać na:{" "}
                  <strong>pok@mediraty.pl</strong>.<br />
                  Te same dane kontaktowe obowiązują także w sprawie współpracy
                  i sprawach technicznych. <br />
                  <em>Oddzwaniamy i odpisujemy natychmiast.</em>
                </p>

                <p>
                  <strong>
                    Czy mogę uzyskać finansowanie, jeżeli pracuję za granicą?
                  </strong>
                  <br />
                  Tak, jest to możliwe, ale musisz zadeklarować uzyskiwanie
                  odpowiednich dochodów, które pozwolą na spłatę zobowiązania.
                </p>
              </div>

              <footer className="text-center terms__footer">
                <a
                  className="position-relative d-inline-block text-decoration-none"
                  href="/"
                >
                  <div className="position-relative d-flex align-items-center svg-container">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.8337 10H4.16699"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.0003 15.8337L4.16699 10.0003L10.0003 4.16699"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="d-inline-block font-italic text-uppercase">
                      Wróć
                    </span>
                  </div>
                </a>
              </footer>
            </div>
          </div>
        </section>
      </main>
    </RootLayout>
  );
};

export default MedipayDescriptionPage;
